import { jsxs as u, Fragment as h, jsx as n } from "react/jsx-runtime";
import { useState as l, useRef as E, useEffect as v } from "react";
import t from "./readmore.module.js";
import { classes as w } from "../../utils/styles.js";
const y = ({
  children: o,
  numberOfLines: r,
  closeText: i,
  openText: c,
  fade: d = !1
}) => {
  const [e, m] = l(!1), [f, p] = l(!1), a = E(null);
  v(() => {
    const s = a.current;
    if (s) {
      const x = s.scrollHeight > s.clientHeight;
      p(x);
    }
  }, [o, r]);
  const g = () => {
    m(!e);
  };
  return /* @__PURE__ */ u(h, { children: [
    /* @__PURE__ */ n(
      "div",
      {
        ref: a,
        style: {
          maxHeight: e ? "none" : `${(r + 1) * 1.1}em`,
          paddingBottom: e ? "0" : "1.1em"
        },
        className: w([
          t.readmore,
          ...!e && d ? [t.hidden] : []
        ]),
        children: o
      }
    ),
    f && /* @__PURE__ */ n("div", { className: t.readmoreExpand, children: /* @__PURE__ */ n("button", { onClick: g, className: t.expandButton, children: e ? i : c }) })
  ] });
};
export {
  y as ReadMore
};
